import { type QuestionnaireFlagsmithKeys } from '@resolve_medical_bills/flagsmith/keys';
import { useGetFlagValue as useGetFlagValueBase } from '@resolve_medical_bills/flagsmith/react';

// Narrows the shared hook to this app's flag keys.
export const useGetFlagValue = (reqFlag: QuestionnaireFlagsmithKeys) =>
  useGetFlagValueBase(reqFlag);
